import { Component } from '@angular/core';
import { Hero } from '../../shared/hero/hero';
import { GalleryGrid } from '../../shared/gallery-grid/gallery-grid';

@Component({
  imports: [Hero, GalleryGrid],
  selector: 'app-gallery',
  styleUrl: './gallery.scss',
  templateUrl: './gallery.html',
})
export class Gallery {}
